module.exports = __webpack_public_path__ + "media/images/icons/star_white-8b2f5a66fdfc826c344ee3fc59f91be9.svg";